import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.scss';
import store from '../src/store/store';
import {MetronicLayoutProvider, MetronicSplashScreenProvider, MetronicSubheaderProvider} from './shared/layout';
import {Provider} from 'react-redux';

ReactDOM.render(
  <React.StrictMode>
      <MetronicLayoutProvider>
          <MetronicSubheaderProvider>
              <MetronicSplashScreenProvider>
                  <Provider store={store}>
                      <App/>
                  </Provider>
              </MetronicSplashScreenProvider>
          </MetronicSubheaderProvider>
      </MetronicLayoutProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
